import React from 'react';
import {typeHoursLabel} from "../../../common/typeHours";
import {isColorLight} from "../../../shared/utils/style";
import {IconSVG} from "../../../shared/ui/icon/IconSVG";

const EventCalendar = ({eventInfo}: { eventInfo?: any }) => {
    const calcColorLabel = () => {
        return isColorLight(eventInfo?.backgroundColor) ? '#000' : '#fff'
    }
    return (
        <div className={'event-calendar-custom d-flex flex-column p-2'} style={{color: calcColorLabel()}}
             title={`${typeHoursLabel[eventInfo?.event?.extendedProps?.type]} | ${eventInfo?.timeText} | ${eventInfo?.event?.title}`}>
            <span>{typeHoursLabel[eventInfo?.event?.extendedProps?.type]}</span>
            <hr/>
            <b>{eventInfo?.timeText}</b>
            <i>{eventInfo?.event?.title}</i>
            <IconSVG icon={'assets/icons/user.svg'} size={'12px'} className={'icon-user ms-auto'}/>
        </div>
    );
};

export default EventCalendar;
